module.exports = __webpack_public_path__ + "img/dl-right4.1cf581dd.gif";